<template>
  <div class="banner grid">

    <div class="grid-center">
      <section class="coupon">
        <div class="coupon-code">
          <VueQrcode value="Wifeed"
                     :options="{ width: 227, margin: 5 }"></VueQrcode>
          <p class="coupon-code-text">Código</p>
        </div>
      </section>
    </div>

    <div class="text-center grid-bottom">
      <button class="btn btn-stretch btn-extra-round text-bold"
              :style="buttonStyle(dataInteraction.estilo)"
              @click="$emit('next')">
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
    import VueQrcode from "@chenfengyuan/vue-qrcode";
    import buttonStyle from '../../../../interactions/components/interaction/mixins/button-style';

    export default {
        components: {
          VueQrcode
        },

        props: {
            dataInteraction: {
                type: Object,
                required: true
            },
        },

        computed: {
            options() {
                return this.dataInteraction.opcoes
            },

            firstOption() {
                return this.options[0] || {
                    estilo: null,
                    nome: null
                }
            },

            secondOption() {
                return this.options[1] || {
                    estilo: null,
                    nome: null
                }
            }
        },

        mixins: [buttonStyle],
    }
</script>

<style lang="scss" scoped>
.coupon {
  display: flex;
  height: 100%;
  align-items: flex-end;
  justify-content: center;

  .coupon-code {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 227px;

    canvas {
      border-radius: 12px 12px 0 0;
      margin-bottom: -20px;
    }

    .coupon-code-text {
      width: 227px;
      border-radius: 0 0 12px 12px;
      text-align: center;
      background: white;
      font-weight: 600;
      font-size: 35px;
      margin: 0;

      z-index: 1;

      height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
